import { authorizedRDRequestsv2 } from "../httpRequest";

export interface StupidBaseResponse {
  '$id': string;
  '$type': string;
}
export interface InitPaymentResponse extends StupidBaseResponse{
  WalletToken:string;
  WalletUri: string;
  Mode: number;
  ConvenienceFeeEnabled: boolean;
  ConvenienceFee: number;
  ConvenienceFeeLabel: string;
  ConvenienceFeeMessage: string;
}
export interface ConvenienceFeeResponse extends StupidBaseResponse{
  ConvenienceFeeEnabled: boolean;
  ConvenienceFee: number;
  ConvenienceFeeLabel: string;
  ConvenienceFeeMessage: string;
}
const walletApiRequest = {
  initiatePayment: async (shoppingCartKey?: string):Promise<InitPaymentResponse> => {
    const query = shoppingCartKey ? `?shoppingCartKey=${shoppingCartKey}` : '';
    const response = await authorizedRDRequestsv2.post<InitPaymentResponse>(
      `webaccesswallet/init-wallet-payment${query}`,
      {}
    );
    return response;
  },
  getConvenienceFee: async (shoppingCartKey: string):Promise<ConvenienceFeeResponse> => {
    const response = await authorizedRDRequestsv2.get<ConvenienceFeeResponse>(
      `webaccesswallet/convenience-fee?shoppingCartKey=${shoppingCartKey}`
    );
    return response;
  },
  getGoogleWalletPassUrl: async (confirmationNumber: number, membershipId?: number): Promise<any> => {
    const params = new URLSearchParams({ confirmationNumber: confirmationNumber.toString() });
    if (membershipId) params.append('membershipId', membershipId.toString());
    return authorizedRDRequestsv2.get(`webaccesswallet/google-wallet-pass-url?${params.toString()}`);
  },
  downloadAppleWalletPass: async (confirmationNumber: number, membershipId?: number): Promise<void> => {
    const params = new URLSearchParams({ confirmationNumber: confirmationNumber.toString() });
    if (membershipId) params.append('membershipId', membershipId.toString());
    const { blob, filename } = await authorizedRDRequestsv2.getBlobWithName(
      `webaccesswallet/apple-wallet-pass?${params.toString()}`
    );
    const fallback = membershipId
      ? `pass-${membershipId}.pkpass`
      : `passes-${confirmationNumber}.pkpasses`;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || fallback;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
  getCustomerAccountCredit: async (): Promise<number> => {
    const response = await authorizedRDRequestsv2.get<number>(
      `webaccesswallet/customer-account-credit`
    );
    return response;
  },
};

export default walletApiRequest;
